import { render } from "./ProfileNE.vue?vue&type=template&id=8861809a&scoped=true"
import script from "./ProfileNE.vue?vue&type=script&lang=js"
export * from "./ProfileNE.vue?vue&type=script&lang=js"

import "98.css?vue&type=style&index=0&id=8861809a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/oliverclark15.github.io.source/oliverclark15.github.io.source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8861809a"]])

export default __exports__